<template>
  <div>
    <v-dialog v-model="hideShow" width="1080px" persistent scrollable content-class="day-record-dialog" aria-label="当日课表">
      <v-card class="dr-shell">
        <v-card-title class="dr-header">
          <span class="dr-symbol"><v-icon size="26" color="#d9363e">mdi-calendar-today-outline</v-icon></span>
          <div class="dr-heading"><h2>{{classDate}} 课表</h2><p>查看当日课次，核对授课安排与核销状态</p></div>
          <span class="dr-count"><strong>{{data.total}}</strong><span>节课次</span></span>
          <v-btn icon aria-label="关闭当日课表" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="dr-body">
          <div class="dr-toolbar">
            <div class="dr-filter"><span class="dr-filter-label">课次状态</span><v-select class="dr-status-filter" :items="statusItems" v-model="query.status" item-text="statusName" item-value="id" aria-label="课次状态" dense outlined hide-details color="#d9363e" /><v-btn class="dr-query" depressed color="#d9363e" dark @click="getDataList"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div>
            <div class="dr-batch"><span v-if="selectedItems.length" class="dr-selection">已选 <strong>{{selectedItems.length}}</strong> 节</span><span v-else class="dr-selection dr-selection-hint">勾选课次后可批量顺延</span><v-btn class="dr-delay" outlined color="#c93640" :loading="batchDelay.submitting" @click="submitBatchDelay"><v-icon left size="17">mdi-calendar-arrow-right</v-icon>批量顺延</v-btn></div>
          </div>

          <v-data-table class="dr-table" :headers="data.headers" v-model="selectedItems" :items="data.list" :loading="query.loading" disable-pagination hide-default-footer fixed-header item-key="id" show-select :mobile-breakpoint="0" loading-text="正在加载，请稍候…" no-data-text="暂无课次">
            <template v-slot:item.courseName="{item}"><div class="dr-course"><strong>{{item.courseName}}</strong><span v-if="item.isAllowBook=='1'" class="dr-book">约</span></div></template>
            <template v-slot:item.className="{item}"><span class="dr-class">{{item.className}}</span></template>
            <template v-slot:item.teacherName="{item}"><span class="dr-teacher">{{item.teacherName}}</span></template>
            <template v-slot:item.weekAt="{item}">{{weekName(item.weekAt)}}</template>
            <template v-slot:item.timeRange="{item}"><span class="dr-time"><v-icon size="14">mdi-clock-outline</v-icon><span>{{item.timeFrom}}</span><span class="dr-time-divider">–</span><span>{{item.timeTo}}</span></span></template>
            <template v-slot:item.roomName="{item}"><span class="dr-room">{{item.roomName}}</span></template>
            <template v-slot:item.status="{item}"><span v-if="item.status=='1'" class="dr-status dr-pending"><i></i>待核销</span><span v-if="item.status=='2'" class="dr-status dr-approved"><i></i>已核销</span><span v-if="item.status=='3'" class="dr-status dr-delayed"><i></i>已顺延</span></template>
            <template v-slot:item.action="{item}"><v-btn class="dr-detail" small outlined color="#c93640" @click="showRecordView(item)">详情<v-icon right size="15">mdi-chevron-right</v-icon></v-btn></template>
            <template v-slot:no-data><div class="dr-empty"><v-icon size="40" color="#a8b7c7">mdi-calendar-blank-outline</v-icon><strong>暂无符合条件的课次</strong><span>可切换课次状态，或选择其他日期查看课表。</span></div></template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="dr-footer">
          <div class="dr-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChanged" dense hide-details outlined v-model="query.size" color="#d9363e" aria-label="每页数量" /><span>条</span></div>
          <span class="dr-total">共 {{data.total}} 节课次</span><v-spacer />
          <v-pagination v-if="Math.ceil(data.total/query.size)>0" class="dr-pagination" :length="Math.ceil(data.total/query.size)" @input="handlePageChanged" :total-visible="5" v-model="query.page" color="#d9363e" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <recordInfoView :show="recordView.show" :recordId="recordView.recordId" @cancel="recordView.show=false" />
  </div>
</template>

<script>
	import global from "../config/global"
	import utils from "../config/utils"
	import recordInfoView from "./record_info_view.vue"
	export default {
		name:"class-record-list",
		components:{
			recordInfoView
		},
		props:{
			show:{
				type:Boolean,
				default:false
			},
			classDate:{
				type:String,
				default:""
			}
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.data.list=[];
					this.selectedItems = [];
					this.getDataList();
				}
			},
		},
		data(){
			return {
				shopId:"",
				hideShow:this.show,
				statusItems:[
					{id:"",statusName:"全部"},
					{id:"1",statusName:"待核销"},
					{id:"2",statusName:"已核销"},
					{id:"3",statusName:"已顺延"},
				],
				selectedItems:[],
				weekItems:global.weekList,
				query:{
					loading:false,
					page:1,
					size:10,
					status:""
				},
				data: {
					total:0,
					headers:[
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '时间段',
							value: 'timeRange',
							sortable: false
						},
						
						{
							text: '教室',
							value: 'roomName',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作',
							value: 'action',
							sortable: false
						},
					],
					list:[],
					
				},
				recordView:{
					show:false,
					recordId:""
				},
				batchDelay:{
					submitting:false
				}
				
			}
		},
		mounted() {
			console.log("day-record-list mounted");
			this.shopId = utils.getCurrentShopId();
			this.getDataList();
		
		},
		methods:{
			handleSizeChanged(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getDataList();
			},
			handlePageChanged(page) {
				this.query.page = page;
				this.getDataList();
			},
			weekName(wk) {
			
				let stName = "未知";
				this.weekItems.forEach((item,index)=>{
					if (item.week == wk){
						stName = item.weekName;
					}
				})
				return stName;
			},
			getDataList(){
				const that = this;
				const classId = this.classId;
				let url = `/edu/class/record/list/by/date/${this.classDate}/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if(this.shopId){
					url += "&shopId="+this.shopId;
				}
				if(this.query.status){
					url += "&status="+this.query.status;
				}
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						console.log(response.data);
						
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				})
			},
			cancel(){
				this.$emit("cancel","")
			},
			showRecordView(item){
				this.recordView.recordId = item.id;
				this.recordView.show = true;
			},
			submitBatchDelay(){
				//批量顺延
				if (this.selectedItems.length == 0){
					this.$noty.error('没有选中的数据');
					return
				}
				let ids = [];
				this.selectedItems.forEach((item,index)=>{
					ids.push(item.id);
				});
				
				this.batchDelay.submitting = true;
				// api
				const that = this;
				let url = `/edu/class/record/batch/delay`;
				
				let postData = {};
				postData.ids = ids;
				
				
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getDataList();
							that.batchDelay.submitting = false;
							that.selectedItems = [];
							return;
						} else {
							that.batchDelay.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.batchDelay.submitting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
		}
	}
	
</script>

<style lang="scss" scoped src="../assets/styles/day-record.scss"></style>
